import {BillingInfo} from '@eitje/api'
import _ from 'lodash'

export const useBankAccountNameFilter = () => {
	const items = _.sortBy(BillingInfo.useAll(), 'account_name').filter(item => item.account_name)

	const filterFn = (item, filterValues) => {
		const {id} = item
		return filterValues.includes(id)
	}

	return {
		items,
		filterFn,
		labelField: 'account_name',
	}
}
